/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Note_Type_InInputs */

const vi_pl_note_type_in = /** @type {(inputs: Pl_Note_Type_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập`)
};

/**

* @param {Pl_Note_Type_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_note_type_in = /** @type {((inputs?: Pl_Note_Type_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Note_Type_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_note_type_in(inputs)
});